import { SUBTYPE_OPTS, time, getSuper, bindPrototype, assignPrivateSymbol, setSymbols, getSymbols, iu, initAbstract, construct, $combine, subtype, implementEngineer, $skip, makeClassSymbol } from '@type.engineering/type-engineer'
import '../'
import '../typedefs/private'
import BuildingBlock, { control } from '../../src/lib/BuildingBlock'
import proxifyState from '../../src/lib/proxify-state'

/**
 * @abstract
 * @extends {guest.maurice.StatefulLoadable}
 */
class _AbstractStatefulLoadable {
  constructor() {
    construct(this)
  }
}
/**
 * Allows to load data from the server while controlling the state.
 * @extends {guest.maurice.StatefulLoadable} ‎
 * @implements {guest.maurice.IStatefulLoadable} ‎
 */
export class AbstractStatefulLoadable extends _AbstractStatefulLoadable {

}
initAbstract(_AbstractStatefulLoadable, 'IStatefulLoadable', /** @this {AbstractStatefulLoadable} */ function () {
  const { asIStateful: { superStateful: { setState, initialState } } } = this
  const state = {
    loading: false,
    errorText: '',
    error: null,
    ...initialState,
  }
  proxifyState(state)
  setState(state)
})
/** @constructor @extends {_AbstractStatefulLoadable} @suppress {checkTypes} */ function __AbstractStatefulLoadable() {}
__AbstractStatefulLoadable.prototype = /** @type {!_AbstractStatefulLoadable} */ ({
  get asIStatefulLoadable() {
    return /** @type {!guest.maurice.BoundIStatefulLoadable} */ (this)
  },
  get superIStatefulLoadable() {
    return /** @type {!guest.maurice.BoundIStatefulLoadable} */ (bindPrototype(_AbstractStatefulLoadable, this))
  },
  get superStatefulLoadable() {
    return /** @type {!guest.maurice.BoundStatefulLoadable} */ (bindPrototype(_AbstractStatefulLoadable, this))
  },
})
AbstractStatefulLoadable.__implement(__AbstractStatefulLoadable, BuildingBlock)

/**
 * @abstract
 * @extends {guest.maurice.StatefulLoader}
 */
class _AbstractStatefulLoader {
  constructor() {
    construct(this)
  }
}
/**
 * Allows to load data from the server while controlling the state.
 * @extends {guest.maurice.StatefulLoader} ‎
 * @implements {guest.maurice.IStatefulLoader} ‎
 */
export class AbstractStatefulLoader extends _AbstractStatefulLoader {

}
initAbstract(_AbstractStatefulLoader, 'IStatefulLoader')
/** @constructor @extends {_AbstractStatefulLoader} @suppress {checkTypes} */ function __AbstractStatefulLoader() {}
__AbstractStatefulLoader.prototype = /** @type {!_AbstractStatefulLoader} */ ({
  get asIStatefulLoader() {
    return /** @type {!guest.maurice.BoundIStatefulLoader} */ (this)
  },
  get superIStatefulLoader() {
    return /** @type {!guest.maurice.BoundIStatefulLoader} */ (bindPrototype(_AbstractStatefulLoader, this))
  },
  get superStatefulLoader() {
    return /** @type {!guest.maurice.BoundStatefulLoader} */ (bindPrototype(_AbstractStatefulLoader, this))
  },
})
AbstractStatefulLoader.__implement(__AbstractStatefulLoader)
